import { render, staticRenderFns } from "./dispute.vue?vue&type=template&id=17a7902e&scoped=true"
import script from "./dispute.vue?vue&type=script&lang=js"
export * from "./dispute.vue?vue&type=script&lang=js"
import style0 from "./dispute.vue?vue&type=style&index=0&id=17a7902e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a7902e",
  null
  
)

export default component.exports